import axios from 'axios';
import ENV from './environment';

const axiosInstance = axios.create({
  baseURL: `${ENV.APP_API_HOST}${parseInt(ENV.APP_API_PORT, 10) !== 80 ? (':' + ENV.APP_API_PORT) : ''}`,
  timeout: 10000
});

export default axiosInstance;
